import { Component, OnInit, inject } from '@angular/core';
import { CurrentUserService } from '../../common/current-user/current-user.service';
import { takePendingSubscription } from '../../services/analytics/customer-analytics';
import { PosthogService } from '../../services/analytics/posthog.service';
import { SubscriptionService } from '../../services/subscription/subscription.service';
import { AdConversionsService } from '@/app/services/analytics/ad-conversions.service';

@Component({
  selector: 'app-thankyou-agency',
  imports: [],
  templateUrl: './thankyou-agency.html',
  styleUrl: './thankyou-agency.css',
})
export class ThankyouAgency implements OnInit {
  private readonly currentUserService = inject(CurrentUserService);
  private readonly posthog = inject(PosthogService);
  private readonly adConversions = inject(AdConversionsService);
  private readonly subscriptionService = inject(SubscriptionService);

  ngOnInit(): void {
    if (!takePendingSubscription('agency')) {
      return;
    }
    const agency = this.currentUserService.focussedAgency;
    const currency = this.subscriptionService.currencyCode()
      ?? agency?.currencyCode
      ?? this.currentUserService.focussedBrand?.currencyCode;
    const stripeCustomerId = agency?.stripeCustomerId ?? agency?.agency?.stripeCustomerId;
    // Stripe only redirects here after checkout succeeded, so the card is on file.
    this.adConversions.trackCardOnFile(agency?.agency?.id ?? agency?.id, agency?.agency?.createdDate ?? agency?.createdDate, { default_payment_method: true });
    this.posthog.posthog.capture('agency_subscription_completed', {
      ...(currency ? { currency_code: currency } : {}),
      ...(stripeCustomerId ? { stripe_customer_id: stripeCustomerId } : {}),
    });
  }
}
